import { z } from "zod";

export const meSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  ephemeral_token: z.string().optional(),
});

export type MeResponse = z.infer<typeof meSchema>;

export const magicLinkSchema = z.object({
  confirmation_id: z.string(),
  email: z.string().email(),
  secret: z.string(),
});

export type MagicLinkResponse = z.infer<typeof magicLinkSchema>;

export const confirmSchema = z.object({
  token: z.string(),
});

export type ConfirmResponse = z.infer<typeof confirmSchema>;
